import GoogleIcon from "@/assets/images/google.svg?react";
import Button from "@/components/Common/Button";
import {useLoginWithGoogle} from "@/hooks/useLogin";
import clsxm from "@/lib/clsxm";
import type {TGoogleRegistrationPayload} from "@/store/types";
import {useGoogleLogin} from "@react-oauth/google";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const GoogleLoginButton: FC<{
  className?: string;
  isDisabled?: boolean;
  onSuccess?: () => void;
  payload?: TGoogleRegistrationPayload;
  text?: string;
}> = ({className, isDisabled, onSuccess, payload, text}) => {
  const {t} = useTranslation("common");
  const {mutate: logInWithGoogle, isPending: isLoggingIn} = useLoginWithGoogle();
  const login = useGoogleLogin({
    onSuccess: codeResponse =>
      logInWithGoogle({access_token: codeResponse.access_token, payload: {type: "company", ...payload}}, {onSuccess}),
  });

  return (
    <Button
      dataTestId="google-login-button"
      onClick={() => login()}
      buttonStyle="White"
      isDisabled={isDisabled || isLoggingIn}
      isLoading={isLoggingIn}
      className={clsxm("enabled:text-neutral-black gap-3", className)}>
      <GoogleIcon className={clsxm("size-7 shrink-0", {"opacity-50": isDisabled})} />
      <span className="font-medium">{text ?? t("login_with_google")}</span>
    </Button>
  );
};

export default GoogleLoginButton;
